import React, { useState } from 'react';
import useBackgroundColor from 'Hooks/useBackgroundColor';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { ApexAdminPortalProvider, useApexAdminPortalStateContext } from './ApexAdminPortalContext';
import View from './View';

const ApexAdminPortal = () => {
  useBackgroundColor('#FFFFFF');
  const { investigationResource, achRelationshipResource } = useApexAdminPortalStateContext();
  const [isCenterCompressed, setIsCenterCompressed] = useState(false);
  const { rootNodeProps } = useEventTrackingLogEvent({ nodeName: 'Apex Admin Portal' });

  React.useEffect(() => {
    if (investigationResource || achRelationshipResource) {
      setIsCenterCompressed(true);
    } else {
      setIsCenterCompressed(false);
    }
  }, [investigationResource, achRelationshipResource]);

  return (
    <View
      isCenterCompressed={isCenterCompressed}
      amplitudeRootNodeProps={rootNodeProps}
    />
  );
};

const ApexAdminPortalWithProvider = () => {
  return (
    <ApexAdminPortalProvider>
      <ApexAdminPortal />
    </ApexAdminPortalProvider>
  );
};

export default ApexAdminPortalWithProvider;
